module.exports = __webpack_public_path__ + "static/media/header-3.4c0f211b.png";